import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Grid, Tabs, Tab, withStyles, TextField } from '@material-ui/core'
import Paper from 'components/theme/Paper'
import { withRouter } from 'react-router-dom'
import { read, list, deleteEntity } from 'actions/data'
import contactLabel from 'utils/contactLabel'
import vastMessageType from 'utils/vast_message_type'
import Notes from './Main/Notes'
import { toggleDialog } from 'actions/view'
import { nanoid } from 'nanoid'
import API_URL from 'utils/ApiUrl'
import { createOrUpdateContact } from 'actions/contacts'

const styles = theme => ({
  li: {
    '&:last-child $line': {
      display: 'none',
    },
    position: 'relative',
    paddingLeft: 15,
    paddingBottom: 20,
    fontSize: 12,
  },
  line: {
    minHeight: 20,
    borderLeft: '2px solid #014c94',
    marginLeft: 4,
    position: 'absolute',
    left: '0',
    top: '16px',
    height: 'calc(100% - 19px)',
  },
  paper: {
    backgroundColor: '#fff',
    border: '1px solid #e5e5e5',
    padding: '8px 20px',
    boxShadow: 'none',
  },
  dot: {
    borderRadius: '50%',
    backgroundColor: '#014c94',
    // display: 'inline-block',
    width: 10,
    height: 10,
    // marginRight: 5,
    position: 'absolute',
    top: 4,
    left: 0,
  },
  text: {
    marginTop: 10,
  },
  tab: {
    [theme.breakpoints.up('xs')]: {
      minWidth: 0,
    },
  },
  createdLi: {
    '&:before': {
      content: '""',
      position: 'absolute',
      left: 4,
      top: -20, // Extend the line upwards
      height: 'calc(100% - 13px)',
      width: 2,
      backgroundColor: '#014c94',
    },
  },
  originallyCreatedLi: {
    // '&:before': {
    //   content: '""',
    //   position: 'absolute',
    //   left: 4,
    //   top: -20, // Extend the line upwards
    //   height: 'calc(100% - 13px)',
    //   width: 2,
    //   backgroundColor: '#014c94',
    // },
    paddingTop: 10,
    '& $dot': {
      top: 14, // Align the dot with the label
    },
  },
  createdText: {
    // marginLeft: 15,
  },
  dateTimeField: {
    // marginLeft: 15,
    marginTop: 2,
  },
})

const formatDateForInput = dateString => {
  if (!dateString) return ''
  const date = new Date(dateString)
  return new Date(date.getTime() - date.getTimezoneOffset() * 60000)
    .toISOString()
    .slice(0, 16)
}

class ActivitiesComponent extends Component {
  state = {
    value: 0,
    whenStarted: null,
  }

  componentDidMount() {
    this.props.list('campaign')
    this.props.list('customform')

    if (this.props.contactID) {
      this.props.read(
        this.props.contactID,
        'activity',
        'inbox/activity',
        'contact_id',
      )

      this.props.read(
        this.props.contactID,
        'campaigns_for_contact',
        'campaign/contact',
        'campaign_id',
        'array',
      )
    }

    if (this.props.contact && this.props.contact.when_started) {
      this.setState({
        whenStarted: formatDateForInput(this.props.contact.when_started),
      })
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.contactID !== this.props.contactID && this.props.contactID) {
      this.props.read(
        this.props.contactID,
        'activity',
        'inbox/activity',
        'contact_id',
      )

      this.props.read(
        this.props.contactID,
        'campaigns_for_contact',
        'campaign/contact',
        'campaign_id',
        'array',
      )
    }

    if (prevProps.contact?.when_started !== this.props.contact?.when_started) {
      this.setState({
        whenStarted: formatDateForInput(this.props.contact.when_started),
      })
    }
  }

  handleWhenStartedChange = event => {
    const newLocalWhenStarted = event.target.value
    this.setState({ whenStarted: newLocalWhenStarted })

    // Convert to UTC when sending to the server
    const utcDate = new Date(newLocalWhenStarted).toISOString()
    this.props.createOrUpdateContact({ when_started: utcDate })
  }

  render() {
    const {
      classes,
      contactID,
      activity,
      campaigns_for_contact,
      contact,
      groupsByID,
      campaigns,
      mobile,
    } = this.props
    const { value } = this.state

    const normalActivities =
      (activity &&
        Array.isArray(activity.conversation) &&
        activity.conversation) ||
      []
    const campaignActivities = campaigns_for_contact || []

    // const combinedActivities = normalActivities
    //   .concat(campaignActivities)
    //   .sort((a, b) => {
    //     const aTime = a.initiating_event_ts || a.utimestamp / 1000000000
    //     const bTime = b.initiating_event_ts || b.utimestamp / 1000000000
    //     return bTime - aTime
    //   })

    const activityLabel = actv => {
      const activityObj = {
        email: actv => {
          if (
            actv.direction === 'inbound' ||
            actv?.thread?.emails?.[0]?.direction === 'inbound'
          ) {
            return `${contactLabel(contact)} sent an email at ${new Date(
              actv.timestamp,
            ).toLocaleString()}`
          }

          if (
            actv.direction === 'outbound' ||
            actv?.thread?.emails?.[0]?.direction === 'outbound'
          ) {
            return `${contactLabel(contact)} was sent an email at ${new Date(
              actv.timestamp,
            ).toLocaleString()}`
          }

          return `${contactLabel(contact)} - email at ${new Date(
            actv.timestamp,
          ).toLocaleString()}`
        },
        sms: actv => {
          if (actv.direction === 'inbound') {
            return `${contactLabel(contact)} sent a text at ${new Date(
              actv.timestamp,
            ).toLocaleString()}`
          }

          if (actv.direction === 'outbound') {
            return `${contactLabel(contact)} was sent a text by ${
              actv?.sms?.originator ||
              actv?.sms?.originator_number ||
              actv?.sms?.originator_id ||
              'Unknown'
            } at ${new Date(actv.timestamp).toLocaleString()}`
          }

          return `${contactLabel(contact)} - text at ${new Date(
            actv.timestamp,
          ).toLocaleString()}`
        },
        call: actv => {
          if (actv.direction === 'inbound') {
            return `${contactLabel(contact)} called at ${new Date(
              actv.timestamp,
            ).toLocaleString()}`
          }

          if (actv.direction === 'outbound') {
            return `${contactLabel(contact)} was called by ${
              actv?.call?.originator
            } at ${new Date(actv.timestamp).toLocaleString()}`
          }

          return `${contactLabel(contact)} - call at ${new Date(
            actv.timestamp,
          ).toLocaleString()}`
        },
        groupadd: actv => {
          return `${contactLabel(contact)} was added to ${
            (actv.added_to_group &&
              actv.added_to_group.id &&
              groupsByID[actv.added_to_group.id] &&
              groupsByID[actv.added_to_group.id].name) ||
            'a group'
          } at ${new Date(actv.timestamp).toLocaleString()}`
        },
        groupremove: actv => {
          return `${contactLabel(contact)} was removed from ${
            (actv.added_to_group &&
              actv.added_to_group.id &&
              groupsByID[actv.added_to_group.id] &&
              groupsByID[actv.added_to_group.id].name) ||
            'a group'
          } at ${new Date(actv.timestamp).toLocaleString()}`
        },
        signup: actv => {
          return `${contactLabel(contact)} signed up at ${new Date(
            actv.timestamp,
          ).toLocaleString()}`
        },
        formsub: actv => {
          const customForm = this.props.customform?.[actv?.formsub?.id]

          return (
            <span>
              {contactLabel(contact)} answered form{' '}
              <u
                onClick={() => {
                  this.props
                    .read(
                      actv?.formsub?.submittal_uri?.slice?.(18),
                      'customform/entry',
                      null,
                      null,
                      'object',
                      actv?.formsub?.submittal_uri?.slice?.(18),
                    )
                    .then(payload => {
                      const sectionsWithIDs =
                        customForm?.form?.sections?.map?.(section => {
                          if (section?.field?.field_options === null) {
                            return {
                              ...section,
                              id: section?.field?.field_name || nanoid(),
                              field: {
                                ...section.field,
                                field_options: [],
                              },
                            }
                          }

                          if (section?.contactfield?.field_options === null) {
                            return {
                              ...section,
                              id: section?.contactfield?.field_name || nanoid(),
                              contactfield: {
                                ...section.contactfield,
                                field_options: [],
                              },
                            }
                          }

                          return {
                            ...section,
                            id:
                              section?.field?.field_name ||
                              section?.contactfield?.field_name ||
                              nanoid(),
                          }
                        }) || []

                      this.props.toggleDialog({
                        open: true,
                        dialog: 'individualFormResponse',
                        options: {
                          response: payload,
                          sectionsByID: sectionsWithIDs.reduce((acc, el) => {
                            acc[el.id] = el
                            return acc
                          }, {}),
                        },
                      })
                    })
                }}
                style={{ cursor: 'pointer' }}
              >
                {customForm?.name}
              </u>{' '}
              at {new Date(actv.timestamp).toLocaleString()}
            </span>
          )
        },
        modify: actv => {
          return `${contactLabel(contact)} was ${
            actv?.modification?.operation === 'create' ? 'created' : 'updated'
          }${
            actv?.modification?.who_modified &&
            actv?.modification?.who_modified !== '_system'
              ? ` by ${actv?.modification?.who_modified}`
              : ''
          } at ${new Date(actv?.timestamp).toLocaleString()}`
        },
        profilechange: actv => {
          const email = actv?.profile_change?.email?.[0]?.address
          const phone = actv?.profile_change?.sms?.[0]?.phone
          const opt_in =
            actv.profile_change?.[email ? 'email' : 'sms']?.[0]?.opt_in
          return `A${email ? 'n email' : ' phone number'} for ${contactLabel(
            contact,
          )} (${email ? email : phone}) was ${
            opt_in ? 'opted in' : 'opted out'
          } at ${new Date(actv?.timestamp).toLocaleString()}`
        },
        assign: actv => {
          return `${contactLabel(contact)} was ${
            actv?.assigned?.source
              ? `reassigned from ${actv?.assigned?.source} to`
              : 'assigned to'
          } ${
            actv?.assigned?.assigned_to ? actv?.assigned?.assigned_to : 'no one'
          } at ${new Date(actv?.timestamp).toLocaleString()}`
        },
      }

      return (
        (activityObj[actv.type] && activityObj[actv.type](actv)) ||
        'Unknown event'
      )
    }

    // can't figure out the width to get this right so we'll just stick with local for now:

    // const timeZoneMap = {
    //   'America/New_York': 'Eastern Time',
    //   'America/Chicago': 'Central Time',
    //   'America/Denver': 'Mountain Time',
    //   'America/Los_Angeles': 'Pacific Time',
    //   'America/Anchorage': 'Alaska Time',
    //   'Pacific/Honolulu': 'Hawaii Time',
    //   'Europe/London': 'British Time',
    //   'Europe/Paris': 'Central European Time',
    //   // Add more as needed
    // }

    // const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone

    return (
      <Grid item xs={12}>
        <Paper className={classes.paper}>
          <Tabs
            value={value}
            onChange={(event, value) => {
              this.setState({ value })
              if (value === 0) {
                this.props.read(
                  this.props.contactID,
                  'activity',
                  'inbox/activity',
                  'contact_id',
                )
              }
              if (value === 1) {
                this.props.read(
                  this.props.contactID,
                  'campaigns_for_contact',
                  'campaign/contact',
                  'campaign_id',
                  'array',
                )
              }
            }}
            variant="fullWidth"
          >
            <Tab classes={{ root: classes.tab }} label="Activity" />
            <Tab classes={{ root: classes.tab }} label="Funnels" />
            <Tab classes={{ root: classes.tab }} label="Notes" />
          </Tabs>
          {value === 0 ? (
            <ul
              style={{
                maxHeight: this.props.inbox
                  ? 'calc(100vh - 505px)'
                  : mobile
                  ? 'calc(100vh - 388px)'
                  : 290,
                overflowY: 'auto',
                listStyle: 'none',
                padding: 0,
              }}
            >
              {activity &&
              activity.conversation &&
              activity.conversation.length ? (
                normalActivities.map((actv, idx) => (
                  <li
                    key={`ActivitiesComponentNoncampaignLi${idx}`}
                    className={classes.li}
                  >
                    <div className={classes.dot} />
                    {activityLabel(actv)}
                    <div className={classes.line} />
                  </li>
                ))
              ) : contactID === 'new' ? (
                <li className={classes.li}>
                  <div className={classes.text}>
                    Activities for this contact will appear here
                  </div>
                </li>
              ) : (
                <li className={classes.li}>
                  <div className={classes.text}>
                    No activities for this contact yet
                  </div>
                </li>
              )}
              {contact && (
                <>
                  <li style={{ paddingBottom: 0 }} className={`${classes.li} ${classes.createdLi}`}>
                    <div className={classes.dot} />
                    <div className={classes.createdText}>
                      <span style={{ color: 'rgba(0, 0, 0, 0.54)' }}>
                        Created
                      </span>{' '}
                      {new Date(contact.when_created).toLocaleString()}
                    </div>
                  </li>
                  <li
                    className={`${classes.li} ${classes.originallyCreatedLi}`}
                    style={{ border: 'none' }}
                  >
                    <div className={classes.dot} />
                    <TextField
                      label="Originally Created"
                      type="datetime-local"
                      value={
                        this.state.whenStarted ||
                        formatDateForInput(contact.when_started)
                      }
                      onChange={this.handleWhenStartedChange}
                      inputProps={{
                        max: formatDateForInput(contact.when_created),
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      className={classes.dateTimeField}
                    />
                  </li>
                </>
              )}
            </ul>
          ) : null}
          {value === 1 ? (
            campaignActivities.length ? (
              <ul
                style={{
                  maxHeight: mobile ? 'calc(100vh - 388px)' : 290,
                  overflowY: 'auto',
                  listStyle: 'none',
                  padding: 0,
                }}
              >
                {campaignActivities.map((actv, idx) => (
                  <li
                    className={classes.li}
                    key={`ActivitiesComponentCampaignLi${idx}`}
                  >
                    <div className={classes.dot} />
                    {`${contactLabel(contact)} is in campaign '${
                      (actv.campaign_id &&
                        campaigns[actv.campaign_id] &&
                        campaigns[actv.campaign_id].name) ||
                      'Unknown'
                    }' ${
                      actv.initiating_event &&
                      vastMessageType[
                        actv.initiating_event.slice(
                          0,
                          actv.initiating_event.indexOf('#'),
                        )
                      ] &&
                      vastMessageType[
                        actv.initiating_event.slice(
                          0,
                          actv.initiating_event.indexOf('#'),
                        )
                      ].description
                        ? `because ${contactLabel(contact)} ${
                            vastMessageType[
                              actv.initiating_event.slice(
                                0,
                                actv.initiating_event.indexOf('#'),
                              )
                            ].description
                          }`
                        : ''
                    }`}
                    <div className={classes.line} />
                    <div
                      style={{
                        position: 'absolute',
                        top: 19,
                        left: 16,
                        textDecoration: 'underline',
                        color: '#0000EE',
                        cursor: 'pointer',
                      }}
                      onClick={() =>
                        this.props
                          .deleteEntity(
                            null,
                            null,
                            `${API_URL}/campaign/${actv.campaign_id}/contact/${this.props.contactID}`,
                          )
                          .then(() =>
                            this.props.read(
                              this.props.contactID,
                              'campaigns_for_contact',
                              'campaign/contact',
                              'campaign_id',
                              'array',
                            ),
                          )
                      }
                    >
                      Remove
                    </div>
                  </li>
                ))}
              </ul>
            ) : (
              <div className={classes.text}>
                This contact is not in any campaign funnels at the moment.
              </div>
            )
          ) : null}
          {value === 2 ? (
            <div style={{ maxHeight: 400, overflowY: 'auto' }}>
              <Notes mobile={mobile} />
            </div>
          ) : null}
        </Paper>
      </Grid>
    )
  }
}

const Activities = withRouter(
  connect(
    state => ({
      activity: state.data?.activity?.[state.addOrEditContact?.contactID],
      campaigns_for_contact:
        state.data?.campaigns_for_contact?.[state.addOrEditContact?.contactID],
      contact:
        state.contacts.contactsWithEmailsByID?.[
          state.addOrEditContact?.contactID
        ],
      groupsByID: state.contacts.groupsByID,
      campaigns: state.data.campaign,
      contactID: state.addOrEditContact.contactID,
      customform: state.data.customform,
    }),
    dispatch =>
      bindActionCreators(
        { read, list, toggleDialog, deleteEntity, createOrUpdateContact },
        dispatch,
      ),
  )(withStyles(styles)(ActivitiesComponent)),
)

export default Activities
